import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col, Card } from "react-bootstrap"
import CTextBox from '../../../Common/CTextBox';
import CDatePicker from '../../../Common/CDatePicker';
import Message from '../../../Common/Message';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { useBoolean } from '@fluentui/react-hooks';
import List from '../../../Templates/List';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import Picker from '../../../Common/Picker';
import CValidator from '../../../Common/CValidator';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { saveMessage, updateMessage } from "../../../../services/sBook/message.service"
import { useGetMessageTopics, useGetSectionPartyFullsByBookId, useGetSectionsByPartyId } from "../../../../hooks/services/sBook/useOfSection"
import { useGetDocumentListByMessage } from '../../../../hooks/services/sBook/useOfDocument';
import { ActionButton } from '@fluentui/react/lib/Button';
import DocumentLinkModal from './DocumentLinkModal';
import { getKeyByValue, isNullUndefined, isNullUndefinedOrEmpty, joinWithoutDupes, visibilityButtonSaveWMessageId, visibilityButtonSend, visibilityButtonSendToApprove } from '../../../../common/Helpers';
import { __DocumentTypeKeys } from '../../../../common/Dictionaries';
import { addListDocumentByMessage, removeDocumentByMessageDocument } from '../../../../services/sBook/document.service';
import moment from "moment-timezone"
import ListPagination from '../../../Templates/List/ListPagination';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import CTextAreaWithPlaceHolders from '../../../Common/CTextArea/indexWithPlaceHolders';
import { getMessageTemplateTopic } from '../../../../services/sBook/section.service';
import { cloneDeep } from 'lodash-es';
import CLabel from '../../../Common/CLabel';
import Loading from '../../../Templates/Site/Loading';
import { SpinnerSize } from '@fluentui/react';


//[##CODELCO-CARD-4-##] Plantillas de Comunicación
//Abre un panel lateral izquierda, con datos de plantilla
function SidePanelCreateWithTemplate(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_ObjMessage = props.objMessage !== null && props.objMessage !== undefined ? props.objMessage : null;
    const inputParam_SetterObjMessage = props.setterObjMessage !== null && props.setterObjMessage !== undefined ? props.setterObjMessage : null;
    const inputParam_TopicList = props.topicList !== null && props.topicList !== undefined ? props.topicList : null;
    const inputParam_SetTopicList = props.setTopicList !== null && props.setTopicList !== undefined ? props.setTopicList : null;
    
    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    
    const [txtNameIsInValid, setTxtNameIsInValid] = useState(false)
    const [txtBodyIsInValid, setTxtBodyIsInValid] = useState(false)
    const [isInvalidTemplateSection, setIsInvalidTemplateSection] = useState(false);

    const [objMensaje, setObjMensaje] = useState(cloneDeep(inputParam_ObjMessage));

    const [getTempleteOnLoad, setGetTempleteOnLoad] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [messageTemplate, setMessageTemplate] = useState(null);
    const [topicList, setTopicList] = useState(cloneDeep(inputParam_TopicList));

    //Funciones de componente.

    //Eventos de componente.
    const isInValidFormControl = () => {
        let isInvalidForm = false;

        if (objMensaje.item_message.title === "") {
            setTxtNameIsInValid(true);
            isInvalidForm = true;
        }

        if (objMensaje.item_message.body === "") {
            setTxtBodyIsInValid(true);
            isInvalidForm = true;
        }
    
        return isInvalidForm;
    }

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onDismissPanel = () => {

        setMessage(null);
        setMessageType(null);
        setShowMessage(false);
    
        setTxtNameIsInValid(false)
        setTxtBodyIsInValid(false)

        setObjMensaje(null);

        inputParam_SetterIsPanelOpen(false);
    };

    const setMessageTitle = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.title = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const setMessageBody = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.body = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    //[##CODELCO-CARD-4-##] Plantillas de Comunicación
    //Se selecciona plantilla
    const onChangeTemplateSection = (currentNode, selectedNodes) => {
        getTemplateData(currentNode)

        let item_message = { ...objMensaje.item_message }
        item_message.topicId = currentNode.checked ? currentNode.id : null;
        item_message.messageTopicCode = currentNode.checked ? currentNode.code : null;

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const getTemplateData = (currentNode) => {
        setShowLoading(true);

        if (currentNode.checked === true) {
            getMessageTemplateTopic(currentNode.id).then((response) => {
                if (response.data.succeeded) {

                    let items = [...topicList];

                    items.forEach(x => {
                        if (x.id === currentNode.id) {
                            x.checked = currentNode.checked;
                        }
                        else {
                            x.checked = false;
                        }
                    })

                    if (!isNullUndefined(response.data.data)) {
                        setMessageTemplate(response.data.data)
                        setMessageTitle(response.data.data.name);
                    }
                    else {
                        setMessageTemplate(undefined)
                        setMessageTitle("");
                    }

                    setTopicList(items); 
                    setShowLoading(false);
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))  
                    setShowLoading(false);
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
                setShowLoading(false);
            });
        }
        else {
            let items = [...topicList];

            items.forEach(x => {
                if (x.id === currentNode.id) {
                    x.checked = currentNode.checked;
                }
                else {
                    x.checked = false;
                }
            })

            setTopicList(items); 
            setShowLoading(false);

            setMessageTemplate(null)
            setMessageTitle("");
        }
    }

    //[##CODELCO-CARD-4-##] Plantillas de Comunicación
    //Apretar guardar los datos son precargados en Asunto y Cuerpo de la comunicación
    const onAcceptTemplate = () => {
        if (!isInValidFormControl()) {
            const aux_objMensaje = cloneDeep(objMensaje);
            const currentTopic = topicList.find(x => x.checked);

            aux_objMensaje.item_message.body = aux_objMensaje.item_message.body.replaceAll('{', '').replaceAll('}', '');
            aux_objMensaje.item_message.topicId = !isNullUndefinedOrEmpty(currentTopic) ? currentTopic.id : 1;

            inputParam_SetterObjMessage && inputParam_SetterObjMessage(aux_objMensaje);
            inputParam_SetTopicList && inputParam_SetTopicList(topicList);
            onDismissPanel();
        }
        else {
            setShowMessage(true)
            setMessageType("error");
            setMessage(t('data-lang-msg-selecatemplateandfillit'))  
        }
    }
    

    const onHideDialogAndPanel = () => {
        //onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                    </Col>
                    <Col xl={12}>
                        <div className='d-flex'>
                            <PrimaryButton
                                onClick={ () => onAcceptTemplate() }
                                styles={_global_buttonStyles}>{ t('data-lang-btn-accept') }</PrimaryButton>


                            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                        </div>
                    </Col>
                </Row>
    };

    useEffect(() => {
        if (getTempleteOnLoad === false) {
            setGetTempleteOnLoad(true);
            const selectedTopicItem = topicList.find(x => x.checked === true);
            if (!isNullUndefinedOrEmpty(selectedTopicItem)) {
                getTemplateData(selectedTopicItem);
            }
        }
    }, [getTempleteOnLoad]);

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-messagetemplate') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ undefined }
                className="left-panel"
                type={PanelType.customNear}
            >
                {
                    objMensaje !== null && objMensaje.item_message !== null &&
                    <Row>
                        {
                            //[##CODELCO-CARD-4-##] Plantillas de Comunicación
                            //Se selecciona plantilla
                            topicList &&
                            <Col>
                                <Picker
                                    data={ topicList !== null ? topicList : [] }
                                    mode="simpleSelect"
                                    className="dropdown-checkbox"
                                    isInValid={ isInvalidTemplateSection }
                                    texts={{ placeholder: t('data-lang-lbl-choose') }}
                                    onChange={ onChangeTemplateSection }
                                    labelText={ t('data-lang-lbl-topic') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ isInvalidTemplateSection } />
                            </Col>
                        }
                        <Col className="pt-3" xl={12}>
                            <Card style={{minHeight: '50px'}}>
                                 {
                                    //[##CODELCO-CARD-4-##] Plantillas de Comunicación
                                    //Formulario carga datos e información con campos a rellenar
                                    showLoading === false && !isNullUndefinedOrEmpty(messageTemplate) &&
                                    <>
                                        <Card.Header style={{height: 'unset'}}><Card.Title>{t('data-lang-boxname-config')}</Card.Title></Card.Header>
                                        <Card.Body>
                                            <Col className="pt-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <CTextBox controlValue={ objMensaje.item_message.title } setterControlValue={ setMessageTitle } isInValid={txtNameIsInValid} textBoxName="name" labelText={ t('data-lang-lbl-title') } />
                                            </Col>
                                            <CTextAreaWithPlaceHolders
                                                labelText={ null }
                                                controlValue={ objMensaje.item_message.body }
                                                setterControlValue={ setMessageBody }
                                                isInvalirControl={ txtBodyIsInValid }
                                                readOnly={false}
                                                entityId={objMensaje.item_message.id}
                                                template={messageTemplate ? messageTemplate.templateBody : null}
                                                placeHolders={messageTemplate ? messageTemplate.topicCustomItem.customItems : null}
                                            />
                                        </Card.Body>
                                    </>
                                }
                                {
                                    showLoading === false && (messageTemplate === null) &&
                                    <div className='m-auto'>{t('data-lang-msg-selecttemplate2')}</div>
                                }
                                {
                                    showLoading === false && (messageTemplate === undefined) &&
                                    <div className='m-auto'>{t('data-lang-msg-selecttemplate3')}</div>
                                }
                                {
                                    showLoading === true &&
                                    <Row className="h-100 pt-2">
                                        <Col className="d-flex align-items-center justify-content-center">
                                            <Loading
                                                inputParam_ShowLoading={true}
                                                inputParam_ShowText={false}
                                                inputParam_Width={'35px'}
                                                inputParam_Height={'35px'}
                                                inputParam_Left={""}
                                                inputParam_Style={{marginTop: 0}}
                                                inputParam_ColClassName={"me-2"}
                                                inputParam_MarginLeft={"auto"}
                                                inputParam_SpinnerSize={SpinnerSize.small} />
                                        </Col>
                                    </Row>
                                }
                            </Card>
                        </Col>
                    </Row>
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>           
        </div>
    );
}

export default SidePanelCreateWithTemplate;